var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import { Modal, ModalBody, ModalFooter, ModalHeader, Typography, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React from 'react';
import { BuildertrendModalBody } from './BuildertrendModalBody';
import { BuildertrendModalFooter } from './BuildertrendModalFooter';
import '../../../../styles/buildertrend.scss';
var createModalHeaderText = function (loggedInUserName, userIsLinked) {
    if (userIsLinked) {
        return 'Disconnect Buildertrend Account';
    }
    return "Welcome, ".concat(loggedInUserName);
};
export var BuildertrendModal = function (_a) {
    var open = _a.open, handleClose = _a.handleClose, userIsLinked = _a.userIsLinked, adminUnlinkRadio = _a.adminUnlinkRadio, setAdminUnlinkRadio = _a.setAdminUnlinkRadio, btApiState = _a.btApiState, setBtApiState = _a.setBtApiState;
    var username = useThdCustomer().username;
    var loggedInUserName = username || '';
    var BuildertrendModalBodyProps = {
        userIsLinked: userIsLinked,
        adminUnlinkRadio: adminUnlinkRadio,
        setAdminUnlinkRadio: setAdminUnlinkRadio,
        btApiState: btApiState,
        setBtApiState: setBtApiState,
    };
    var BuildertrendModalFooterProps = {
        handleClose: handleClose,
        userIsLinked: userIsLinked,
        btApiState: btApiState,
        setBtApiState: setBtApiState,
        adminUnlinkRadio: adminUnlinkRadio,
    };
    return (React.createElement(Modal, { open: open, onClose: handleClose, size: "md" },
        React.createElement(ModalHeader, { onClose: handleClose },
            React.createElement(Typography, { variant: "h4" }, createModalHeaderText(loggedInUserName, userIsLinked))),
        React.createElement(ModalBody, null,
            React.createElement(BuildertrendModalBody, __assign({}, BuildertrendModalBodyProps))),
        React.createElement(ModalFooter, null,
            React.createElement(BuildertrendModalFooter, __assign({}, BuildertrendModalFooterProps)))));
};
